import React from "react";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import swipedata from "../constant/swipe";

const Swipe = () => {
  return (
    <div
      name="swipe"
      className="md:w-[70%] w-[90%] mt-[120px] lg:mt-[170px] mx-auto z-[-1]"
    >
      <div className="pb-8">
        <p className="text-4xl font-bold inline border-b-4 text-gray-300 border-pink-600">
          Html and Css Projects
        </p>
        <p className="py-6 text-white"> Check out some of my recent projects</p>
      </div>

      {/* ----------------------------- */}
      <Carousel
        style={{ zIndex: 0 }}
        autoPlay
        infiniteLoop
        showArrows
        showStatus={false}
        showIndicators={false}
        stopOnHover
      >
        {swipedata.map((ele, idx) => (
          <div
            key={idx}
            style={{
              backgroundImage: `url(${ele.source})`,
              backgroundSize: "cover",
            }}
            className="shadow-lg w-[98%] shadow-[#040c16] group h-[250px] sm:h-[400px] md:h-[490px] rounded-md flex justify-center items-center mx-auto  transition-all  "
          >
            {/* Hover Effects */}
            <div className="opacity-0 p-5 rounded group-hover:bg-blue-500  group-hover:opacity-100">
              <span className="text-2xl font-bold text-black tracking-wider">
                {ele.name}
              </span>
              <div className="pt-8 text-center">
                <a href={ele.live} target="_blank" rel="noreferrer">
                  <button className="text-center rounded-lg px-4 py-3 m-2 bg-white text-gray-700 font-bold text-lg">
                    Demo
                  </button>
                </a>
                <a href={ele.github} target="_blank" rel="noreferrer">
                  <button className="text-center rounded-lg px-4 py-3 m-2 bg-white text-gray-700 font-bold text-lg">
                    Code
                  </button>
                </a>
              </div>
            </div>
          </div>
        ))}
      </Carousel>
    </div>
  );
};

export default Swipe;
